import { defineStore } from "pinia";
import { RootState, SelectedSite } from "@/types/root-types";
import {
    AnnArborSiteID, 
    DearbornSiteID, 
    FlintSiteID 
} from "@/types/sse-types";

import { useAnnArbor } from "./sites/ann-arbor";
import { useFlint } from "./sites/flint";
import { useDearborn } from "./sites/dearborn";

const AnnArborState = useAnnArbor();
const FlintState = useFlint();
const DearbornState = useDearborn();

export const siteLookUp = {
    /**
     * Getters are reactive data properties. They need to be used
     * in order to provide dynamic data values to the DOM.
     */
    [AnnArborSiteID] : { 
        name: "Ann Arbor",
        emergency: AnnArborState.emergencyCalls, 
        emergencyGetter: AnnArborState.getAnnArborEmergencyCalls,
        nonEmergency: AnnArborState.nonEmergencyCalls,  
        nonEmergencyGetter: AnnArborState.getAnnArborNonEmergencyCalls
    },
    [DearbornSiteID] : { 
        name: "Dearborn",
        emergency: DearbornState.emergencyCalls,  
        emergencyGetter: DearbornState.getDearbornEmergencyCalls,
        nonEmergency: DearbornState.nonEmergencyCalls, 
        nonEmergencyGetter: DearbornState.getDearbornNonEmergencyCalls
    },
    [FlintSiteID] : { 
        name: "Flint", 
        emergency: FlintState.emergencyCalls, 
        emergencyGetter: FlintState.getFlintEmergencyCalls,
        nonEmergency: FlintState.nonEmergencyCalls,  
        nonEmergencyGetter: FlintState.getFlintNonEmergencyCalls 
    }
}

export const useRoot = defineStore("root", {
    state: (): RootState => ({
        error: false,
        version: "1.0.0",
        showSidebar: false,
        selectedSite: SelectedSite.AnnArbor,
        playAlertBell: false
    }),
    actions: {},
    getters: {
        getSidebarStatus: (state) => state.showSidebar,
        getErrorStatus: (state) => state.error,
        getSelectedSite: (state) => state.selectedSite,
        getSelectedSiteName: (state) => siteLookUp[state.selectedSite].name,
        getSelectedSiteEmergencyData: (state) => siteLookUp[state.selectedSite].emergencyGetter,
        getSelectedSiteNonEmergencyData: (state) => siteLookUp[state.selectedSite].nonEmergencyGetter,
        getAlertStatus: (state) => state.playAlertBell
    }
})